const init = require('./fpa_mobile_menu.js');

$(document).ready(setTimeout(init, 2000));
